<template>
    <div>
        <div class="row">
            <div class="col-md-5">
                <div class="show-certificate">
                    <div v-if="!user.certificado_vencimento">
                        <div class="alert alert-danger">
                            <h5>
                                <i class="icon fa fa-warning"></i> {{
                                                $t('message.certificate_not_installed')}}</h5>
                        </div>
                        <p>
                            <a href="http://mbd.com.br/blog/agenda/" target="_blank" class="btn btn-default float-left">
                                <i class="fa fa-cart-plus"></i> {{ $t('message.want_to_buy')}}</a>
                        </p>
                        <p>
                            <a @click="addCertificado()" class="btn btn-success float-right">
                                <i class="fa fa-plus"></i> {{ $t('message.register_certificate')}}</a>
                        </p>
                    </div>
                    <div v-if="user.certificado_vencimento">
                        <div v-if="checkVencimento(user.certificado_vencimento) == 1" class="alert alert-success">
                            <h5>
                                <i class="fa fa-check"></i> Seu certificado está cadastrado
                                corretamente.</h5>
                            <span class="float-right"> Vencimento:
                                <strong>{{formatDate(user.certificado_vencimento)}}</strong>
                            </span>
                            <br>
                        </div>
                        <div v-else-if="checkVencimento(user.certificado_vencimento) == 2" class="alert alert-warning">
                            <h5><i class="fa fa-exclamation-circle"></i>
                                {{$t('message.certificate_almost_expired')}}</h5>
                            <span class="float-right"> Vencimento:
                                <strong>
                                    {{formatDate(user.certificado_vencimento)}}</strong>
                            </span>
                            <br>
                        </div>
                        <div v-else class="alert alert-danger">
                            <h5><i class="fa fa-times"></i> {{$t('message.certificate_expired')}}</h5>
                            <span class="float-right"> Vencimento:
                                <strong>
                                    {{formatDate(user.certificado_vencimento)}}</strong>
                            </span>
                            <br>
                            <br>
                            <i class="fa fa-info-circle"></i> {{$t('message.certificate_expired_msg')}}
                        </div>
                        <div class="form-group" v-if="checkVencimento(user.certificado_vencimento) !== 1">
                            <a href="http://www.lojambd.com.br/" target="_blank" class="btn btn-default float-left">
                                <i class="fa fa-cart-plus"></i> {{ $t('message.want_to_buy')}}</a>
                        </div>
                        <div class="form-group">
                            <button type="button" @click="destroyCertificate()" :disabled="loading"
                                class="btn btn-danger float-right">
                                <i class="fa fa-trash"></i> {{ $t('message.remove_certificate')}} <i v-show="loading"
                                    class="fa fa-circle-o-notch fa-spin"></i></button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-7">
                <div class="well certificate-box">
                    <h3>{{ $t('words.doubts')}}</h3>
                    <div class="row">
                        <div class="col-sm-6">
                            <div>{{ $t('message.still_with_doubts')}}</div>
                            <div>{{ $t('message.contact_us')}}</div>
                            <h2 class="glyphicon glyphicon-phone-alt"></h2>
                            (12) 3152-9360 / (12) 9 7404-9319
                        </div>
                        <div class="col-sm-6">
                            <img src="../../../assets/certificate-picture.png" width="250">
                        </div>
                    </div>
                    <p>{{ $t('message.help_1')}}
                        <a href="http://www.mbd.com.br/suporte/" target="_blank">{{
                                            $t('message.help_2')}}</a>
                    </p>
                </div>
            </div>
        </div>
        <m-certificado ref="mCertificado"></m-certificado>
    </div>
</template>
<script>
    import MCertificado from './m-certificado';
    export default {
        components: {
            MCertificado,
        },
        data() {
            return {
                signatureCertificate: false,
                loading: false,
                mCetificadoKey: 'mCertificado'
            };
        },
        computed: {
            user() {
                return this.$store.state.user.data;
            },
        },
        methods: {
            addCertificado() {
                this.$refs.mCertificado.resetForm();
                $('#ModalCertificado').modal('toggle');
            },
            checkVencimento(payload) {
                let today = new Date((new Date()).toString().substring(0, 15));
                payload = new Date(payload);
                if (payload <= today) {
                    return 3;
                } else {
                    today.setDate(today.getDate() + 30);
                    return payload < today ? 2 : 1;
                }
            },
            destroyCertificate() {
                let span = document.createElement('span');
                span.innerHTML =
                    `${trans('message.confirm_delete_alert')}<br><br>
      <small>${trans('message.confirm_delete')}<br>
      <strong style='word-wrap: break-word;'>Certificado Digital A1</strong> ? </small><br><br>`;
                Swal.fire({
                    title: trans('words.confirm'),
                    icon: 'warning',
                    html: span,
                    allowOutsideClick: false,
                    showCancelButton: true,
                    cancelButtonText: trans('words.close'),
                    confirmButtonText: trans('words.confirm'),
                    confirmButtonClass: 'btn btn-danger btn-lg float-right',
                    cancelButtonClass: 'btn btn-default btn-lg float-left',
                    buttonsStyling: false,
                    reverseButtons: true,
                    showLoaderOnConfirm: true,
                    preConfirm: (confirm) => {
                        if (confirm) {
                            return this.$store
                                .dispatch('destroyCertificate')
                                .then(response => {
                                    return response;
                                });
                        }
                    }
                }).then(response => {
                    let text = document.createElement('span');
                    text.innerHTML = response.value.message;
                    if (response.value.status === 'success') {
                        this.$store.dispatch('getUserData');
                        this.successSwal(response.value);
                    } else {
                        this.errorSwal(response.value);
                    }
                });
            },
        }
    };
</script>